import { redirectReplace } from '../../../../core/store/actions/HistoryRouting';
import { PAGE_ROUTES } from '../../../../constants/pageRoutes';

export function navigateToReportedConversationsList() {
    redirectReplace(PAGE_ROUTES.REPORTED_CONVERSATIONS);
}
